export default __webpack_public_path__ + "static/media/page20.43685fd7.jpg";